import React from 'react'
import { TextField, InputAdornment } from '@mui/material'

const BuildTextField = ({ value, placholder, setter, endIcon, type, error, helperText, label, required }) => {
  const handleChange = (setter) => (event) => setter(event.target.value)

  return (
    <TextField 
      fullWidth
      size="small"
      variant='outlined'
      placeholder={placholder}
      value={value}
      type={type}
      error={error}
      helperText={helperText}
      label={label}
      required={required}
      sx={{
        width: 'max-content',
        color: 'primary.main',
        textAlign: 'center',
        '& .MuiOutlinedInput-root': {
          backgroundColor: 'primary.contrastText',
        },
      }}
      onChange={handleChange(setter)}
      autoComplete={'off'}
      // MUI hides the placeholder until the label shrinks, so an unshrunk `label`
      // would swallow `placholder` at rest. No-op when no label is passed.
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            {endIcon}
          </InputAdornment>
        ),
      }}
    />
  )
}

export default BuildTextField
